import { Colors, Metrics } from '../../theme';

export default {
  default: {
    width: Metrics.base * 60,
    height: Metrics.base * 56.2,
    borderRadius: Metrics.base,
    backgroundColor: Colors.white,
    padding: Metrics.baseMargin * 2.5
  },
  contentTnc: {
    width: Metrics.base * 52,
    height: Metrics.base * 41.8,
    overflow: 'auto',
    color: Colors.black
  },
  buttonBoxTnc: {
    marginTop: Metrics.baseMargin * 1.5,
    textAlign: 'center',
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-between',
  }
};
